import React, { useMemo, useState } from "react";
import { useIntl } from "react-intl";
import { ParagraphTemplate, SceneTemplate } from "@/model";
import { useTemplates } from "@/query/template";
import { useScenarioId } from "@/hook/useScenarioId";
import { Typeahead, TypeaheadInput, TypeaheadOptions } from "@/component/input";

import { ParagraphInputsProps } from "../model";


const ParagraphTemplateCardInputs: React.FC<ParagraphInputsProps<ParagraphTemplate>> = (props) => {
    const { paragraph, onChange } = props;

    const intl = useIntl();
    const scenarioId = useScenarioId();

    const [searchKeyword, setSearchKeyword] = useState("");

    const { data: templates } = useTemplates(scenarioId);

    const onChangeTemplate = (template?: SceneTemplate) => {
        if (!template) {
            return;
        }
        onChange({
            ...paragraph,
            data: {
                ...paragraph.data,
                template_id: template.id,
                template_name: template.name
            }
        });
    };

    const selectedTemplateName = useMemo(() => {
        return templates?.find(template => template.id === paragraph.data?.template_id)?.name ?? "";
    }, [templates, paragraph.data?.template_id]);

    const filteredTemplates = useMemo(() => {
        return templates?.filter(template => template.name.includes(searchKeyword)) ?? [];
    }, [templates, searchKeyword]);

    return (
        <div className="col-span-2 flex flex-col gap-1.5">
            <div className="h-6 flex items-center field-label">
                {intl.formatMessage({ id: "i04069" })}
            </div>
            <Typeahead selection={selectedTemplateName}
                       onChange={itemName => {
                           onChangeTemplate(templates?.find(item => item.name === itemName));
                       }}
            >
                <TypeaheadInput required
                                defaultValue={selectedTemplateName}
                                placeholder={intl.formatMessage({ id: "i04074" })}
                                onChange={e => setSearchKeyword(e.target.value)}
                />
                <TypeaheadOptions options={filteredTemplates.map(template => template.name)} />
            </Typeahead>
        </div>
    );
};

export default ParagraphTemplateCardInputs;
